const recentlyViewedSlice = {
  initialState: {
    status: "",
    product: [],
    extra: [],
  },
  reducers: {
    addProduct: (state, action) => {
      const newProduct = action.payload.product;

      // Check if the new product already exists in the list
      const productExists = state.product.some(
        (prod) => prod._id === newProduct._id
      );

      // If the product doesn't exist, add it to the list
      if (!productExists) {
        const updatedProductList = [newProduct, ...state.product.slice(0, 5)];

        return {
          ...state,
          product: updatedProductList,
        };
      }

      // If the product exists, return the current state without making changes
      return state;
    },
    // Remove other reducers or keep them as needed
  },
};

export default recentlyViewedSlice;
